<template>
  <MoleculeButtonBack
    :url="url"
    :label="label"
    :background-color="buttonBackgroundColor"
    :text-color="buttonTextColor"
    :hover-background-color="buttonHoverBackgroundColor"
    :flush="flush"
    @click="emit('click', $event)"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const props = defineProps({
  breadcrumbs: { type: Array as PropType<any[]>, required: true },
  backgroundColor: { type: String, required: false, default: undefined },
  flush: { type: Boolean, required: false, default: false },
  textColor: { type: String, required: false, default: undefined },
  theme: { type: String, required: false, default: undefined },
})

const emit = defineEmits(['click'])

const { t } = useI18n()

// The "back" crumb is the one before the current page.
const crumb = props.breadcrumbs.length > 1 ? props.breadcrumbs[props.breadcrumbs.length - 2] : undefined

const url = crumb?.url
const label = crumb?.labelTemplate ? t(crumb.labelTemplate) : crumb?.label

const buttonBackgroundColor = computed(() => (props.theme === 'light-blue' ? 'bg-app-secondary-10-blue--royal-blue' : props.backgroundColor))
const buttonHoverBackgroundColor = computed(() => (props.theme === 'light-blue' ? 'hover:bg-black' : undefined))
const buttonTextColor = computed(() => (props.theme === 'light-blue' ? 'text-app-secondary-10-yellow--cream' : props.textColor))
</script>
